import { useState } from 'react';
import { Pause, Play } from 'lucide-react';
import { AnomalyOverview, SetScanControl } from './types';

export default function ScanControls({ scan, disabled, onChange }: {
  scan?: AnomalyOverview['scan'];
  disabled: boolean;
  onChange: (command: SetScanControl) => Promise<void>;
}) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const control = scan?.control;
  const paused = control?.enabled === false;
  async function toggle() {
    if (!control || saving) return;
    setSaving(true);
    setError('');
    try {
      await onChange({ enabled: !control.enabled, expectedVersion: control.version });
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'Kunne ikke ændre analysestatus.');
    } finally {
      setSaving(false);
    }
  }
  return (
    <section className={`anomaly-scan-controls ${paused ? 'paused' : ''}`} aria-label="Automatisk analyse">
      <div>
        <strong role="status">
          {!control ? 'Henter analysestatus…' : paused ? 'Automatisk analyse er sat på pause' : 'Automatisk analyse er aktiv · hver time'}
        </strong>
        <p>
          {scan?.isRunning
            ? 'En analyse er i gang og kan færdiggøres, selvom du sætter på pause.'
            : paused
            ? 'Nye analyser er stoppet. Gemte hændelser kan stadig vurderes.'
            : 'Gælder alle aktive flow- og GSM-anlæg. Genoptagelse starter ved næste planlagte analyse.'}
        </p>
        {error && <p role="alert" className="anomaly-scan-control-error">{error}</p>}
      </div>
      <button className="anomaly-button" disabled={disabled || saving || !control} onClick={toggle}>
        {paused ? <Play size={16} /> : <Pause size={16} />}
        {saving ? 'Gemmer…' : paused ? 'Genoptag analyse' : 'Sæt analyse på pause'}
      </button>
    </section>
  );
}
